var favicon = require('./favicons/absa/favicon-32x32.png');

module.exports = {
  name: 'absa',
  favicon: favicon,
  logo: 'absa.png',
  logo_text: '',
  logo_link: '',
  logo_fineprint: '',
  margintop: '114px',
  minheight: 'calc(100vh - 300px)',
  google_font: 'Source+Sans+Pro:wght@400;600;700',
  font_headings: 'Source Sans Pro',
  font_body: 'Source Sans Pro, Futura, "Century Gothic", AppleGothic, sans-serif',
  font: {
    input_weight: 100
  },
  fonts: {
    h1: {
      desktop: 'bold 2.5rem "Source Sans Pro", Helvetica, Arial, sans-serif',
      mobile: 'bold 2.5rem "Source Sans Pro", Helvetica, Arial, sans-serif'
    },
    h2: {
      desktop: 'bold 2rem "Source Sans Pro", Helvetica, Arial, sans-serif',
      mobile: 'bold 2rem "Source Sans Pro", Helvetica, Arial, sans-serif'
    },
    h3: {
      desktop: 'bold 1.75rem "Source Sans Pro", Helvetica, Arial, sans-serif',
      mobile: 'bold 1.75rem "Source Sans Pro", Helvetica, Arial, sans-serif'
    },
    h4: {
      desktop: 'bold 1.5rem "Source Sans Pro", Helvetica, Arial, sans-serif',
      mobile: 'bold 1.5rem "Source Sans Pro", Helvetica, Arial, sans-serif'
    },
    h5: {
      desktop: 'bold 1.25rem "Source Sans Pro", Helvetica, Arial, sans-serif',
      mobile: 'bold 1.25rem "Source Sans Pro", Helvetica, Arial, sans-serif'
    },
    h6: {
      desktop: 'bold 1rem "Source Sans Pro", Helvetica, Arial, sans-serif',
      mobile: 'bold 1rem "Source Sans Pro", Helvetica, Arial, sans-serif'
    },
    p: {
      desktop: '1rem/1.7rem -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif',
      mobile: '1rem/1.7rem -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif'
    },
    li: {
      desktop: '1rem/1.7rem -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif',
      mobile: '1rem/1.7rem -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif'
    }
  },
  colours: {
    primary: {
      darkest: 'rgb(80,10,40)',
      darker: 'rgb(100,0,50)',
      dark: '#FA551E',
      base: '#FA551E',
      light: 'rgb(240,50,90)',
      lighter: 'rgb(240,90,120)',
      lightest: '#fff',
      light_text: '#fff',
      dark_text: '#282828',
      border_colour: 'transparent',
      gradient: 'linear-gradient(45deg, rgb(80,10,40) 0%, rgb(135,10,60) 100%);',
      gradient_hover: 'linear-gradient(45deg, rgb(80,10,40) 0%, rgb(135,10,60) 100%);'
    },
    secondary: {
      darkest: 'rgb(150,5,40)',
      darker: 'rgb(170,5,45)',
      dark: 'rgb(190,0,40)',
      base: 'rgb(220,0,50)',
      light: 'rgb(245,45,40)',
      lighter: 'rgb(250,85,30)',
      lightest: '#fff',
      light_text: '#fff',
      dark_text: '#282828',
      border_colour: 'transparent',
      gradient: 'linear-gradient(45deg, rgb(150,5,40) 0%, rgb(190,0,40)100%);',
      gradient_hover: 'linear-gradient(45deg, rgb(150,5,40) 0%, rgb(190,0,40) 100%);'
    },
    tertiary: {
      darkest: 'rgb(45,35,35)',
      darker: 'rgb(45,35,35)',
      dark: 'rgb(115,100,100)',
      base: 'rgb(135,10,60)',
      light: 'rgb(245,45,40)',
      lighter: 'rgb(255,120,15)',
      lightest: '#fff',
      light_text: '#fff',
      dark_text: '#282828',
      border_colour: 'transparent',
      gradient: 'linear-gradient(45deg, rgb(45,35,35) 0%, rgb(115,100,100) 100%);',
      gradient_hover: 'linear-gradient(45deg, rgb(45,35,35) 0%, rgb(115,100,100) 100%);'
    },
    ghost: {
      darkest: 'transparent',
      darker: 'transparent',
      dark: 'transparent',
      base: 'transparent',
      light: 'transparent',
      lighter: 'transparent',
      lightest: 'transparent',
      light_text: 'rgb(135,10,60)',
      dark_text: '#282828',
      border_colour: 'rgb(135,10,60)',
      gradient: 'none',
      gradient_hover: 'none'
    },
    'ghost-secondary': {
      darkest: 'transparent',
      darker: 'transparent',
      dark: 'transparent',
      base: 'transparent',
      light: 'transparent',
      lighter: 'transparent',
      lightest: 'transparent',
      light_text: 'rgb(135,10,60)',
      dark_text: '#282828',
      border_colour: 'rgb(135,10,60)',
      gradient: 'none',
      gradient_hover: 'none'
    },
    'ghost-tertiary': {
      darkest: 'transparent',
      darker: 'transparent',
      dark: 'transparent',
      base: 'transparent',
      light: 'transparent',
      lighter: 'transparent',
      lightest: 'transparent',
      light_text: 'rgb(135,10,60)',
      dark_text: '#282828',
      border_colour: 'rgb(135,10,60)',
      gradient: 'none',
      gradient_hover: 'none'
    },
    filled: {
      darkest: '#fff',
      darker: '#fff',
      dark: '#fff',
      base: '#fff',
      light: '#fff',
      lighter: '#fff',
      lightest: '#fff',
      light_text: 'rgb(80,10,40)',
      dark_text: '#282828',
      border_colour: 'rgb(175,20,75)',
      gradient: 'none',
      gradient_hover: 'none'
    },
    neutral: {
      darkest: '#282828',
      darker: '#58595B',
      dark: '#808285',
      base: '#d1d6da',
      light: '#DCDDDE',
      lighter: '#F3F5F7',
      lightest: '#F3F5F7',
      light_text: '#fff',
      dark_text: '#2f3946',
      border_colour: 'transparent',
      gradient: 'none',
      gradient_hover: 'none'
    },
    danger: {
      darkest: '#662222',
      darker: '#D94949',
      dark: '#D94949',
      base: '#FF5656',
      light: '#FF6F6F',
      lighter: '#FF9999',
      lightest: '#FFBBBB',
      light_text: '#fff',
      dark_text: '#662222',
      border_colour: 'transparent',
      gradient: 'none',
      gradient_hover: 'none'
    }
  }
};